import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Heart } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-16">
      <div className="container pad-xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Heart className="text-red-500" size={24} />
              <span className="heading-2">PodioSoins+</span>
            </div>
            <p className="body-small text-gray-600">
              Votre santé, nos soins. Spécialiste en soins de plaies et de pieds à Longueuil.
            </p>
            <div className="flex space-x-4">
              <a 
                href="tel:819-469-4419" 
                className="btn-secondary px-4 py-2"
              >
                <Phone size={16} />
              </a>
              <a 
                href="mailto:salwa.connexion@gmail.com" 
                className="btn-secondary px-4 py-2"
              >
                <Mail size={16} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="heading-3">Navigation</h3>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="body-small text-gray-600 hover:text-blue-600 transition-colors">
                Accueil
              </Link>
              <Link to="/about" className="body-small text-gray-600 hover:text-blue-600 transition-colors">
                À propos
              </Link>
              <Link to="/services" className="body-small text-gray-600 hover:text-blue-600 transition-colors">
                Services
              </Link>
              <Link to="/testimonials" className="body-small text-gray-600 hover:text-blue-600 transition-colors">
                Témoignages
              </Link>
              <Link to="/contact" className="body-small text-gray-600 hover:text-blue-600 transition-colors">
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="heading-3">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Phone size={16} className="text-blue-600 mt-1 flex-shrink-0" />
                <div>
                  <p className="body-small font-medium">{contactInfo.phone}</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail size={16} className="text-blue-600 mt-1 flex-shrink-0" />
                <div>
                  <p className="body-small">{contactInfo.email}</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin size={16} className="text-blue-600 mt-1 flex-shrink-0" />
                <div>
                  <p className="body-small">{contactInfo.address}</p>
                  <p className="caption">{contactInfo.serviceArea}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Hours & Emergency */}
          <div className="space-y-4">
            <h3 className="heading-3">Horaires</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Clock size={16} className="text-green-600 mt-1 flex-shrink-0" />
                <div>
                  <p className="body-small font-medium">Heures d'ouverture</p>
                  <p className="caption">{contactInfo.hours.weekdays}</p>
                  <p className="caption">{contactInfo.hours.friday}</p>
                </div>
              </div>
              <div className="bg-red-50 p-3 rounded-lg">
                <p className="body-small font-medium text-red-800">
                  {contactInfo.emergencyHours}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-8 pt-8">
          <div className="flex justify-center items-center">
            <p className="caption text-gray-500">
              © 2025 PodioSoins+. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;